var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgId = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14066 4.55481H7.87878V10.4454H9.14066C9.83652 10.4454 10.403 9.90114 10.403 9.2327V5.7677C10.403 5.09903 9.83652 4.55481 9.14066 4.55481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 0.46875H2.8125C1.51805 0.46875 0.46875 1.51805 0.46875 2.8125V12.1875C0.46875 13.482 1.51805 14.5313 2.8125 14.5313H12.1875C13.482 14.5313 14.5312 13.482 14.5312 12.1875V2.8125C14.5312 1.51805 13.482 0.46875 12.1875 0.46875ZM5.39062 11.4844H4.45312V3.51563H5.39062V11.4844ZM11.4844 9.23274C11.4845 9.53442 11.4217 9.83281 11.2999 10.1088C11.181 10.3781 11.0103 10.6214 10.7977 10.8248C10.5823 11.0315 10.3295 11.1953 10.0528 11.3074C9.76307 11.4249 9.45328 11.485 9.14062 11.4844H6.79688V3.51563H9.14062C9.45656 3.51563 9.76336 3.57516 10.053 3.69234C10.332 3.80578 10.5827 3.96797 10.7979 4.17492C11.013 4.38188 11.1818 4.62305 11.3002 4.89047C11.4217 5.16696 11.4845 5.4657 11.4844 5.76774V9.23274Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgId);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/id.5b9a9600c37b176aa90b86d92b4c17d0.svg";